import { createSelector } from 'reselect'
import { filterForUnique } from '../utils/array'
import { getGradeLevels } from './manifest'
import {
  groupEnrollmentsByMasterCourses,
  mapMasterCourseEnrollmentsObject
} from '../utils/courses'

const _getUserEnrolledMasterCourses = ({
  state,
  includePastMasterCourses,
  filterOutWhereEngagementTrackingDisabled
}) => {
  let currentMasterCourses = []
  let pastMasterCourses = []
  const userCourses = state.usercourses
  const gradeLevels = getGradeLevels(state)
  const academicYears = state.academicyears.items

  if (userCourses.currentUserCourses.length > 0) {
    currentMasterCourses = userCourses.currentUserCourses.map(cuc => {
      if (
        filterOutWhereEngagementTrackingDisabled &&
        cuc.course_section.engagement_tracking_disabled
      ) {
        // don't want to include the mc under above conditions
        return null
      }

      return {
        ...cuc.master_course,
        active: true,
        gradeLevel: gradeLevels.find(
          gl => gl.id === cuc.master_course.grade_level_id
        ),
        academicYear: academicYears.find(
          ay => ay.id === cuc.master_course.academic_year_id
        )
      }
    })
  }

  if (includePastMasterCourses && userCourses.pastUserCourses.length > 0) {
    pastMasterCourses = userCourses.pastUserCourses.map(cuc => {
      if (
        filterOutWhereEngagementTrackingDisabled &&
        cuc.course_section.engagement_tracking_disabled
      ) {
        // don't want to include the mc under above conditions
        return null
      }

      return {
        ...cuc.master_course,
        active: false,
        gradeLevel: gradeLevels.find(
          gl => gl.id === cuc.master_course.grade_level_id
        ),
        academicYear: academicYears.find(
          ay => ay.id === cuc.master_course.academic_year_id
        )
      }
    })
  }

  // filter out null mcs, filter out duplicate mc's
  return filterForUnique(
    currentMasterCourses.concat(pastMasterCourses).filter(mc => !!mc),
    'id'
  )
}

export const getUserEnrolledMasterCourses = createSelector(
  [_getUserEnrolledMasterCourses],
  masterCourses => masterCourses
)

const _getJourneysGroupedByMasterCourse = ({
  state,
  excludeNonAcademicYearCourses
}) => {
  const gradeLevels = getGradeLevels(state)
  const academicYears = state.academicyears.items
  const frameworkSubjects = state.manifest.data.framework_subjects
  const masterCourses = groupEnrollmentsByMasterCourses(
    state.usercourses.currentUserCourses.concat(
      state.usercourses.pastUserCourses
    )
  )

  return mapMasterCourseEnrollmentsObject({
    masterCourses,
    gradeLevels,
    academicYears,
    frameworkSubjects,
    excludeNonAcademicYearCourses
  })
}

export const getJourneysGroupedByMasterCourse = createSelector(
  [_getJourneysGroupedByMasterCourse],
  masterCourses => masterCourses
)
